import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Alert, Stack, IconButton, InputAdornment } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import { useThemeColors } from "../../../hooks/useThemeColors";

interface TokenRevealDialogProps {
  token: string | null;
  onClose: () => void;
}

const TokenRevealDialog: React.FC<TokenRevealDialogProps> = ({ token, onClose }) => {
  const headingColor = useThemeColors().primary[100];
  const handleCopy = () => {
    if (!token) return;
    navigator.clipboard.writeText(token);
    toast.success("Token copied to clipboard", { position: "top-right" });
  };

  return (
    <Dialog open={Boolean(token)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: headingColor }}>API Token</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Alert severity="warning">
            This token will not be shown again. Copy it now and store it securely.
          </Alert>
          <TextField
            value={token || ""}
            fullWidth
            InputProps={{
              readOnly: true,
              sx: { fontFamily: "monospace", fontSize: "0.8125rem" },
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleCopy} edge="end">
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TokenRevealDialog;
